module.exports = __webpack_public_path__ + "static/media/IPERAL.40e8e078.svg";